module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAAUCAYAAABMDlehAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAAB3RJTUUH4AgLDS87li4/+AAAABRJREFUCNdjqKio+M/EwMDAQDsCAPFAAo4UCXRYAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/general-icons/separator_icon_gray.png
// module id = 257
// module chunks = 0